import {IS_COPILOT, IS_HEAD, IS_MEMBER, IS_PILOT, IS_SUPER_HEAD} from "./roleTypes";
import {useSelector} from "react-redux";


export const userHasException = (hasException) => {
    return hasException
}


export const DisplayForPilotAndCopilot = (props) => {
    const {id: currentUserId, roles} = useSelector(state => state.currentUser)
    if (IS_HEAD(roles) || IS_PILOT(currentUserId, props.pilot.id) || IS_COPILOT(currentUserId, props.copilot) || userHasException(props.hasException)) {
        return (
            props.component
        )
    } else {
        return null
    }
}

export const DisplayForPilotCopilotAndMembers = (props) => {
    const {id: currentUserId, roles} = useSelector(state => state.currentUser)
    const {pilot, copilot, members} = useSelector(state => state.project)
    if (IS_HEAD(roles)
        || IS_PILOT(currentUserId, pilot.id)
        || IS_COPILOT(currentUserId, copilot)
        || IS_MEMBER(currentUserId, members)
        || userHasException(props.hasException)) {
        return (
            props.component
        )
    } else {
        return null
    }
}

export const DisplayForAmbassador = (props) => {
    const {roles} = useSelector(state => state.currentUser)

    if (IS_SUPER_HEAD(roles) || userHasException(props.hasException)) {
        return (
            props.component
        )
    } else {
        return null

    }
}

export const DisplayForHead = (props) => {
    const {roles} = useSelector(state => state.currentUser)
    if (IS_HEAD(roles) || userHasException(props.hasException)) {
        return (
            props.component
        )
    } else {
        return null
    }
}
